<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-column flex h-full text-base">
        <div class="flex items-center border-b border-solid py-4 dark:border-contrast-yellow">
            <div class="w-10"></div>
            <h2 class="flex-1 text-center text-base font-semibold">{{ 'CART_REMOVE_VALUE_CODE' | translate }}</h2>
            <button [attr.aria-label]="'CLOSE' | translate" (click)="cancel()" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto border-b border-solid dark:border-contrast-yellow">
            <div class="p-4">
                {{ code.serialNumber }}
                <ng-container *ngIf="code.discountValue"> (-{{ code.discountValue / 10 }}%)</ng-container>
            </div>
        </div>
        <div class="m-4">
            <ion-button
                class="orb-app-light:bg-danger m-0 w-full rounded-lg bg-red-600 dark:bg-contrast-yellow"
                (click)="handleDeleteClick()"
                size="large"
                slot="end"
                color="none">
                <ion-label class="text-base font-bold normal-case text-white dark:text-contrast-black">
                    {{ 'CART_REMOVE_VALUE_CODE_BUTTON' | translate }}
                </ion-label>
            </ion-button>

            <ion-button
                class="orb-app-light:text-secondary m-0 w-full text-primary"
                (click)="cancel()"
                size="large"
                fill="clear">
                <ion-icon
                    class="text-35xl text-secondary dark:text-contrast-yellow"
                    aria-hidden="true"
                    src="{{ assetsPath$ | async }}/img/back.svg">
                </ion-icon>
                <ion-label
                    class="orb-app-light:font-bold sr-app-light:font-semibold text-base font-medium normal-case dark:text-contrast-yellow"
                    >{{ 'CART_KEEP_THIS_VALUE_CODE_IN_CART_BUTTON' | translate }}
                </ion-label>
            </ion-button>
        </div>
    </div>
</div>
